import React from 'react';
import { useAtom } from 'jotai';
import type { SortDescriptor } from '@react-types/shared';

import { notificationsListParamsAtom } from '@/store';
import { NotificationItem } from '@/types';

export function useNotificationsSorting(items: NotificationItem[]) {
  const [params, setParams] = useAtom(notificationsListParamsAtom);

  const handleSortChange = (sortDescriptor: SortDescriptor) => {
    const { column, direction } = sortDescriptor;

    if (!column || !direction) {
      setParams((prev) => ({
        ...prev,
        filters: { ...prev.filters, sort: undefined, order: undefined }
      }));
      return;
    }

    setParams((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        sort: column as string,
        order: direction === 'ascending' ? 'asc' : 'desc'
      }
    }));
  };

  const sortDescriptor: SortDescriptor = React.useMemo(() => {
    const sort = params.filters.sort;
    const order = params.filters.order;

    if (!sort || !order) {
      return {} as SortDescriptor;
    }

    return {
      column: sort,
      direction: order === 'asc' ? 'ascending' : 'descending'
    } as SortDescriptor;
  }, [params.filters.sort, params.filters.order]);

  // For now, return items as-is since sorting is handled by the backend
  const sortedItems = React.useMemo(() => items, [items]);

  return {
    sortDescriptor,
    handleSortChange,
    sortedNotifications: sortedItems
  };
}
